import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ClientSideRowModelModule } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Papa from 'papaparse';

// Custom cell renderer for Google Maps Link
const GoogleMapLinkCellRenderer = (props) => {
    if (!props.value) {
        return <span>No Link Available</span>;
    }

    return (
      <a href={props.value} target="_blank" rel="noopener noreferrer">
        View on Google Maps
      </a>
    );
  };

  const EntitySiteLinkCellRenderer = (props) => {
    if (!props.value) {
        return <span>No Link Available</span>;
    }
    
    return (
      <a href={props.value} target="_blank" rel="noopener noreferrer">
        View Site
      </a>
    );
  };

  // Custom Cell Renderer that changes background color based
  // on prop value.
  // Y = YES = GREEN
  // N = NO = RED
  // U = UNKNOWN = YELLOW
  const DateOpenCellRenderer = (props) => {
    let backgroundColor = 'white';
    if (props.value === 'In Session') {
      backgroundColor = 'darkseagreen';
    } else if (props.value === 'Not In Session') {
      backgroundColor = 'darksalmon';
    } else if (props.value === 'Unknown') {
      backgroundColor = 'lightgrey';
    }
  
    return (
      <div style={{ backgroundColor }}>
        {props.value}
      </div>
    );
  }

const ActivityTable = () => {
    const [rowData, setRowData] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState({
        june_16_20: true,
        june_23_27: true,
        june_30_04: true,
        july_07_11: true,
        july_14_18: true,
        july_21_25: true,
        july_28_01: true,
        august_04_08: true,
        august_11_15: true,
        august_18_22: true,
      });

    useEffect(() => {
        Papa.parse('/data/2025.csv', {
          download: true,
          header: true,
          complete: (result) => {
            setRowData(result.data);
          },
        });
      }, []);

      const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setVisibleColumns((prev) => ({
          ...prev,
          [name]: checked,
        }));
      };

      const columnDefs = [
        { headerName: 'Name', field: 'entity_name' },
        { headerName: 'Registration Open', field: 'entity_registration_open' },
        { headerName: 'Registration Open Date', field: 'entity_registration_open_date' },
        { headerName: 'Type', field: 'entity_type' },
        { headerName: 'Locale', field: 'entity_locale' },
        { headerName: 'Min Age', field: 'entity_age_min' },
        { headerName: 'Max Age', field: 'entity_age_max' },
        { headerName: 'Hours', field: 'full_or_partial_day' },
        { 
            headerName: 'Web Site', 
            field: 'entity_web_link',
            cellRenderer: EntitySiteLinkCellRenderer,
        },
        {
            headerName: 'Google Maps Link',
            field: 'entity_google_maps_link',
            cellRenderer: GoogleMapLinkCellRenderer,
        },
        ...(visibleColumns.june_16_20 ? [{
            headerName: 'JUNE 16 - JUNE 20',
            field: 'open_date_june_16_20',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.june_23_27 ? [{
            headerName: 'JUNE 23 - JUNE 27',
            field: 'open_date_june_23_27',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.june_30_04 ? [{
            headerName: 'JUNE 30 - JULY 04',
            field: 'open_date_june_30_04',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.july_07_11 ? [{
            headerName: 'JULY 07 - JULY 11',
            field: 'open_date_july_07_11',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.july_14_18 ? [{
            headerName: 'JULY 14 - JULY 18',
            field: 'open_date_july_14_18',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.july_21_25 ? [{
            headerName: 'JULY 21 - JULY 25',
            field: 'open_date_july_21_25',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.july_28_01 ? [{
            headerName: 'JULY 28 - AUGUST 01',
            field: 'open_date_july_28_01',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.august_04_08 ? [{
            headerName: 'AUGUST 04 - AUGUST 08',
            field: 'open_date_august_04_08',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.august_11_15 ? [{
            headerName: 'AUGUST 11 - AUGUST 15',
            field: 'open_date_august_11_15',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
          ...(visibleColumns.august_18_22 ? [{
            headerName: 'AUGUST 18 - AUGUST 22',
            field: 'open_date_august_18_22',
            cellRenderer: DateOpenCellRenderer,
          }] : []),
      ];

      return (
        <div>
          <h1>2025 Summer Camps</h1>
          <h3>The following information may not be accurate or up to date! It's always best to check with individual camps
            for the most current information. We make no endorsement about the camps listed here.
          </h3>

          <div>
            <h2>2025 Session Weeks</h2>
            <p>
                Check the boxes below to show if each camp is running a session that week. This does not mean the camp has availability, just that they 
                have a session that week.
            </p>
        <label>
          <input
            type="checkbox"
            name="june_23_27"
            checked={visibleColumns.june_23_27}
            onChange={handleCheckboxChange}
          />
          JUNE 23 - JUNE 27
        </label> <br />
        <label>
          <input
            type="checkbox"
            name="june_30_04"
            checked={visibleColumns.june_30_04}
            onChange={handleCheckboxChange}
          />
          JUNE 30 - JULY 04
        </label><br />
        <label>
          <input
            type="checkbox"
            name="july_07_11"
            checked={visibleColumns.july_07_11}
            onChange={handleCheckboxChange}
          />
          JULY 07 - JULY 11
        </label><br />
        <label>
          <input
            type="checkbox"
            name="july_14_18"
            checked={visibleColumns.july_14_18}
            onChange={handleCheckboxChange}
          />
          JULY 14 - JULY 18
        </label><br />
        <label>
          <input
            type="checkbox"
            name="july_21_25"
            checked={visibleColumns.july_21_25}
            onChange={handleCheckboxChange}
          />
          JULY 21 - JULY 25
        </label><br />
        <label>
          <input
            type="checkbox"
            name="july_28_01"
            checked={visibleColumns.july_28_01}
            onChange={handleCheckboxChange}
          />
          JULY 28 - AUGUST 01
        </label><br />
        <label>
          <input
            type="checkbox"
            name="august_04_08"
            checked={visibleColumns.august_04_08}
            onChange={handleCheckboxChange}
          />
          AUGUST 04 - AUGUST 08
        </label><br />
        <label>
          <input
            type="checkbox"
            name="august_11_15"
            checked={visibleColumns.august_11_15}
            onChange={handleCheckboxChange}
          />
          AUGUST 11 - AUGUST 15
        </label><br />
        <label>
          <input
            type="checkbox"
            name="august_18_22"
            checked={visibleColumns.august_18_22}
            onChange={handleCheckboxChange}
          />
          AUGUST 18 - AUGUST 22
        </label><br /><br />
      </div>

          <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              pagination={true}
              paginationPageSize={10}
              modules={[ClientSideRowModelModule]}
            />
          </div>
        </div>
    );
};

export default ActivityTable;